// extracted by mini-css-extract-plugin
module.exports = {"container":"colorBox_container__LXezD","light-blue":"colorBox_light-blue__y86FW","warning-yellow":"colorBox_warning-yellow__T_1bE","red":"colorBox_red__dhTDB"};